import { MatDialogConfig } from '@angular/material/dialog';

/**
 * Standardized modal sizes for the course setup flow.
 *
 * Large    – large or complex content (e.g. course detail card)
 * Medium  – typical setup steps (e.g. user creation, enrollment dialogs)
 * Compact – simple confirmations (e.g. success message after setup)
 *
 * Every size enforces a viewport-based max height (90 vh).
 * When content exceeds that limit the modal body scrolls internally.
 */

type DialogSizeConfig = Pick<
  MatDialogConfig,
  'height' | 'maxHeight' | 'maxWidth' | 'width'
>;

const DIALOG_MAX_HEIGHT = '90vh';

export const DIALOG_SIZE_LARGE: DialogSizeConfig = {
  width: '90vw',
  maxWidth: '1280px',
  maxHeight: DIALOG_MAX_HEIGHT,
};

export const DIALOG_SIZE_MEDIUM: DialogSizeConfig = {
  width: '90vw',
  maxWidth: '800px',
  maxHeight: DIALOG_MAX_HEIGHT,
};

export const DIALOG_SIZE_COMPACT: DialogSizeConfig = {
  // Fixed width keeps simple dialogs narrow; maxWidth ensures mobile responsiveness
  width: '478px',
  maxWidth: '95vw',
  maxHeight: DIALOG_MAX_HEIGHT,
};
